var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn__back-to-top",style:({ marginBottom: _vm.browser.isIE || _vm.browser.isEdge ? '40px' : '0px' }),on:{"click":_vm.onBackToTopClick}},[_c('i',{staticClass:"icon icon--back-to-top"}),(!_vm.hideLabel)?_c('p',[_vm._v(_vm._s(_vm.$t('common.backToTop')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }